import { BarcodeScannerButton } from "components";
import type { BarcodeScannerButtonProps } from "components/BarcodeScannerButton";
import type { ReactStoryblokComponent } from "types/storyblok";

const BarcodeScannerButtonAdapter = ({
  blok: { buttonText, dividerText },
}: ReactStoryblokComponent<BarcodeScannerButtonProps>) => (
  <BarcodeScannerButton buttonText={buttonText} dividerText={dividerText} />
);

export default BarcodeScannerButtonAdapter;
